import { ModuleWithProviders, NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { createStorageSyncConfig, StoreSyncConfig } from './storage-sync.config';
import { StorageSyncEffects } from './storage-sync.effects';

@NgModule({
  imports: [EffectsModule.forFeature([StorageSyncEffects])],
})
export class StorageSyncModule {
  static forRoot<T>(config: Partial<StoreSyncConfig<T>>): ModuleWithProviders<StorageSyncModule> {
    return {
      ngModule: StorageSyncModule,
      providers: [createStorageSyncConfig(config)],
    };
  }
}
